import { setAuthHeaders } from "../utils/common";
import axiosInstance from "../axiosHttp";
import API_URL from "../constant/api.config";
import isEmpty from 'lodash/isEmpty';
import { trim } from "lodash";

export const getAllInquiries = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance
    .post(
      API_URL + "/get-inquiries/" + limit + "/" + current_page,
      filterObj,
      {
        headers,
      }
    )
    .then((response) => {
      if (response.data.status === true) {
        return response.data;
      }
      return [];
    })
    .catch((err) => {
      console.log("Error ====> ", err);
    });
};

export const getAllSendInquiries = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance
    .post(
      API_URL + "/get-send-inquiries/" + limit + "/" + current_page,
      filterObj,
      {
        headers,
      }
    )
    .then((response) => {
      if (response.data.status === true) {
        return response.data;
      }
      return [];
    })
    .catch((err) => {
      console.log("Error ====> ", err);
    });
};



export const getMyInquiries = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance.post(API_URL + '/get-my-inquiries/' + limit + '/' + current_page, filterObj,
    {
      headers
    }
  ).then((response) => {
    if (response.data.status === true) {
      return response.data;
    }
    return [];

  }).catch((err) => {
    console.log("Error ====> ", err);
  })
}

export const getMySendInquiries = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance
    .post(
      API_URL + "/get-my-send-inquiries/" + limit + "/" + current_page,
      filterObj,
      {
        headers,
      }
    )
    .then((response) => {
      if (response.data.status === true) {
        return response.data;
      }
      return [];
    })
    .catch((err) => {
      console.log("Error ====> ", err);
    });
};

export const getAllAdminInquiries = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance
    .post(
      API_URL + "/get-admin-inquiries/" + limit + "/" + current_page,
      filterObj,
      {
        headers,
      }
    )
    .then((response) => {
      if (response.data.status === true) {
        return response.data;
      }
      return [];
    })
    .catch((err) => {
      console.log("Error ====> ", err);
    });
};

export const FilterMockInquiries = (filter) => async () => {
  const headers = setAuthHeaders();
  return await axiosInstance.post(API_URL + "/filter-mock-inquiries", filter, { headers }).then((response) => {
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  }).catch((err) => {
    console.log("Error ==== ", err);
  });
}

export const getMockInquiry = (id) => async () => {
  const headers = setAuthHeaders();
  return await axiosInstance.get(`${API_URL}/get-mock-inquiry/${id}`, { headers })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.log("Error ==== ", err);
    });
}

export const deleteInquiry = (id) => async () => {
  const headers = setAuthHeaders();
  return await axiosInstance.delete(`${API_URL}/delete-inquiry/${id}`, { headers }).then((response) => {
    if (response.status === 200) {
      console.log("response =========== ", response);
      return response.data;
    } else {
      return null;
    }
  }).catch((err) => {
    console.log("Error === ", err);
  })
}

export const getAllSupllierInq = () => async () => {
  
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/get-admin-supplier-inquiries", { headers }).then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    }).catch((err) => {
      console.log("Error ==== ", err);
    });
}

export const getOneInquiry = (id) => async () => {
  
    const headers = setAuthHeaders();
    return await axiosInstance.get(`${API_URL}/get-inquiry/${id}`, { headers }).then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    }).catch((err) => {
      console.log("Error ==== ", err);
    });
}



export const getInqSuggetions = (searchTxt,current_inq_id,type) => async (dispatch) => {
    const headers = setAuthHeaders();
    const search_txt = trim(searchTxt);
    
    try {
      
        const res = await axiosInstance.post(API_URL + "/inquiry-suggetions", {search_txt,current_inq_id,type}, { headers });
        dispatch({ type: "GET_SUGGESTIONS_SUCCESS", payload: res.data });

        return res.data;

    } catch (err) {
        console.log("Error ==== ", err);
        dispatch({ type: "GET_SUGGESTIONS_FAIL", payload: err?.response?.data || err.message });

        throw err;
    }
};

export const assignBulkInqquiry = (data) => async () => {
  // const headers = setAuthHeaders();
  // return await axiosInstance.post(API_URL + "/assign-bulk-inquiries", data, { headers }).then((response) => {
  //    return response;
  // }).catch((err) => {
  //   console.log("Error ==== ", err);
  // });
  const headers = setAuthHeaders();
  try {
    return await axiosInstance.post(
      API_URL + "/assign-bulk-inquiries",
      data,
      { headers }
    );
  } catch (err) {
    console.log("Error ==== ", err?.response?.data);
    throw err; // let the component handle it
  }
}

export const getAllSupplierInquiryReport = (limit, current_page, filterObj) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance
    .post(
      API_URL + "/supplier-inquiry-report/" + limit + "/" + current_page,
      filterObj,
      {
        headers,
      }
    )
    .then((response) => {
      if (response.data.status === true) {
        return response.data;
      }
      return [];
    })
    .catch((err) => {
      console.log("Error ====> ", err);
    });
};


export const getReportSupplierInq = (id, limit, current_page, filterObj) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance
        .post(
            API_URL + "/supplier-inquiry-report/" + id + "/" + limit + "/" + current_page,
            filterObj,
            {
                headers,
            }
        )
        .then((response) => {
            if (response.data.status === true) {
                return response;
            }
            return [];
        })
        .catch((err) => {
            console.log("Error ====> ", err);
        });
};

export const isOpenInquiry = (id) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance
        .post(
            API_URL + "/supplier-open-inquiry/" + id,
            {
                headers,
            }
        )
        .then((response) => {
            if (response.data.status === true) {
                return response.data;
            }
            return [];
        })
        .catch((err) => {
            console.log("Error ====> ", err);
        });
};

export const getInquiryRawData = (filter) => async () => {
    // console.log("Filter ============ ", filter);
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/filter-inquiry-raw-data", filter, { headers }).then((response) => {
        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    }).catch((err) => {
        console.log("Error ==== ", err);
    });
}

export const deleteRawData = (id) => async () => {
  const headers = setAuthHeaders();
  return await axiosInstance.delete(`${API_URL}/delete-member-data/${id}`, { headers }).then((response) => {
    if (response.status === 200) {
      console.log("response =========== ", response);
      return response.data;
    } else {
      return null;
    }
  }).catch((err) => {
    console.log("Error === ", err);
  })
}

export const inquiryReportDetail = (payload) => async () => {
  const headers = setAuthHeaders();
  try {
    const response = await axiosInstance.post(
      API_URL + "/filter-inquiry-report-data",
      payload,           
      { headers }
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (err) {
    console.log("Error ==== ", err);
    return null;
  }
};

export const getOtherCategorySupplier = (search = "") => async () => {
  const headers = setAuthHeaders();
  try {
    const response = await axiosInstance.post(
      API_URL + "/get-other-supplier-inquiries",
      { search },
      { headers }
    );
    return response.status === 200 ? response.data : { status: false, data: [] };
  } catch (err) {
    console.log("Error ==== ", err);
    return { status: false, data: [] };
  }
};





















